export class DropdownEvent
{
	public static UNFOLD: string = "component:dropdown:unfold";
	public static FOLD : string = "component:dropdown:fold";
}
